const CategoryTypeEnum = {
  SELECTION: "Selection",
  SLIDER: "Slider",
};

class BaseCategory {
  constructor(CategoryName, CategoryType, bCategoryCollapsed, Func) {
    this.CategoryName = CategoryName;
    this.CategoryType = CategoryType;
    this.bCategoryCollapsed = bCategoryCollapsed;
    this.Func = Func;
  }
}

class SelectionCategory extends BaseCategory {
  constructor(
    CategoryName,
    ItemArray,
    bCategoryCollapsed,
    Func,
    Translate = false
  ) {
    super(CategoryName, CategoryTypeEnum.SELECTION, bCategoryCollapsed, Func);
    this.ItemArray = ItemArray;
    this.bShowMore = false;
    this.bMoreToShow = false;
    this.Func = Func;
    this.Translate = Translate;
  }
  ItemHasOption(ID, Value) {
    return this.Func(ID, Value);
  }
}

class SliderCategory extends BaseCategory {
  constructor(
    CategoryName,
    minValue,
    maxValue,
    decimals,
    bCategoryCollapsed,
    Func
  ) {
    super(CategoryName, CategoryTypeEnum.SLIDER, bCategoryCollapsed, Func);
    this.decimals = decimals;
    this.minValue = minValue;
    this.maxValue = maxValue;
    this.sliderMinValue = minValue;
    this.sliderMaxValue = maxValue;
    this.sliderInputMinValue = minValue;
    this.sliderInputMaxValue = maxValue;
    this.Func = Func;
  }
  ItemHasOption(item, min, max) {
    return this.Func(item, min, max);
  }
}

export { SelectionCategory, SliderCategory, CategoryTypeEnum };
